<template>
    <div
        ref="step"
        class="form-step"
        :data-step="index + 1"
    >
        <template
            v-for="(element, number) in fields"
            :key="Object.keys(element)[0]"
        >
            <component
                :is="getFieldComponent(Object.keys(element)[0])"
                :number="startFrom + number"
                :step="index + 1"
                :data="Object.values(element)[0]"
                @submit-step="submitStep"
            />
        </template>
    </div>
</template>

<script setup>
import { watch, computed, nextTick, ref, defineAsyncComponent } from 'vue';
import { isMatch } from '@mixins/utils/conditions';
import { getParameters, updateParameter } from '@mixins/quiz/history';
import { submitStep } from '@form/utils/submit';

const emit = defineEmits(['updateHeight']);
const props = defineProps({
    index: {
        type: Number,
        required: true,
    },

    elements: {
        type: Object,
        required: true,
    },

    startFrom: {
        type: Number,
        required: true,
    },

    show: {
        type: Boolean,
        required: true,
    },
});

const step = ref(null);

const componentCache = {};
const getFieldComponent = type => {
    if (!componentCache[type]) {
        componentCache[type] = defineAsyncComponent(() => import(`./fields/${type}/v1.0.0/zoe-form-${type}.vue`));
    }
    return componentCache[type];
};

const fields = computed(() => {
    const fields = [];

    props.elements.forEach(element => {
        const data = element[Object.keys(element)[0]];
        const conditionals = data._info.conditionals || [];
        let hide = false;

        conditionals.forEach(conditional => {
            if (conditional.value.conditionals && isMatch(conditional.value.conditionals)) hide = true;
        });

        if (hide) return;

        fields.push(element);
    });

    return fields;
});

watch(() => props.show, value => {
    if (value === true) {
        nextTick(() => {
            emit('updateHeight', step.value.getBoundingClientRect().height);
        });

        if (parseInt(getParameters()['form_step']) !== props.index + 1 && props.index !== 0) {
            updateParameter('form_step', props.index + 1);
        }
    }
});
</script>
